<template>
  <v-container grid-list-md>
    <p class="display-2 text-center font-weight-bold indigo--text">{{pageTitle}}</p>
    <v-row justify="center">
      <v-col col="6" align="centerg">
        <SLIDESHOW v-for="(item, i) in articleList" :key="i" :article="item" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SLIDESHOW from "./Slideshow.vue";
export default {
  props:["articleList","pageTitle"],
  data() {
    return {
    };
  },
  components: {
    SLIDESHOW
  },
  methods: {
    goTo: function(page) {
      this.$router.push({ name: page });
    }
  }
};
</script>

